import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/antd/es/form/index.js
// module id = null
// module chunks = 